export default __webpack_public_path__ + "static/media/yaba-terminal.499f14fb.png";